import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'clsx';
import { DropdownMenu } from '../dropdown-menu';
import { DropdownMenuItem } from '../dropdown-menu-item';
import { DropdownMenuToggler } from '../dropdown-menu-toggler';
import style from './quantity-select.module.less';

const MAXIMUM_DROPDOWN_QUANTITY = 25;
const SMALL_FONT_SIZE_QUANTITY = 10000;

const validateValue = (inputValue, currentQuantity, maxQuantity, onCurrentQuantityChanged) => {
  const intInputValue = Number.parseInt(inputValue, 10);
  if (Number.isNaN(intInputValue)) {
    onCurrentQuantityChanged(1);
    return;
  }
  const newValue = Math.min(Math.max(1, intInputValue), maxQuantity);
  if (newValue === currentQuantity) {
    return;
  }
  onCurrentQuantityChanged(newValue);
};

const renderInput = (maxQuantity, currentQuantity, onCurrentQuantityChanged) => {
  return (
    <input
      className={style['number-input']}
      onBlur={(e) => {
        const { target } = e;
        setTimeout(() => {
          if (target.contains(document.activeElement)) {
            return;
          }
          validateValue(target.value, currentQuantity, maxQuantity, onCurrentQuantityChanged);
        }, 0);
      }}
      onChange={(e) => {
        onCurrentQuantityChanged(e.target.value);
      }}
      onFocus={(e) => e.target.select()}
      onKeyPress={(e) => {
        if (e.key !== 'Enter') {
          return;
        }
        e.target.blur();
      }}
      type='number'
      value={currentQuantity}
    />
  );
};

export const QuantitySelect = ({ maxQuantity, currentQuantity, onCurrentQuantityChanged }) => {
  if (maxQuantity === 1) {
    return <div className={classnames(style['quantity-select'], style['single-value'])}>1</div>;
  }
  if (maxQuantity <= MAXIMUM_DROPDOWN_QUANTITY) {
    const dropdownItems = [];
    for (let x = 1; x <= maxQuantity; x += 1) {
      dropdownItems.push(x);
    }

    return (
      <div className={classnames(style['quantity-select'], style['value-with-dropdown'])}>
        {renderInput(maxQuantity, currentQuantity, onCurrentQuantityChanged)}
        <DropdownMenu className={style['dropdown-menu']} menuPosition='bottom-right'>
          <DropdownMenuToggler className={style['dropdown-menu-button']} />
          {dropdownItems.map((item) => {
            return (
              <DropdownMenuItem key={item} className={style['dropdown-menu-item']} onClick={() => onCurrentQuantityChanged(item)}>
                {item}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenu>
      </div>
    );
  }
  return (
    <div
      className={classnames(style['quantity-select'], style['value-without-dropdown'], {
        [style['big-number']]: maxQuantity >= SMALL_FONT_SIZE_QUANTITY,
      })}
    >
      {renderInput(maxQuantity, currentQuantity, onCurrentQuantityChanged)}
    </div>
  );
};

QuantitySelect.propTypes = {
  maxQuantity: PropTypes.number.isRequired,
  currentQuantity: PropTypes.number.isRequired,
  onCurrentQuantityChanged: PropTypes.func.isRequired,
};
